import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels'
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend
);

export default function CustomizedDialogs({value, dialogTitle, handleOpenClose, openClose, lineGraphDataset }) {
  const [selectedButton, setSelectedButton] = React.useState('lastYear');
  const getAxisLabel = () => {
    const d = new Date();
    let year = d.getFullYear();
    if (selectedButton === 'lastYear' || selectedButton === 'lastSixMonth') {
      return `FY ${year.toString().replace('20', '')}`
    } else {
      return `FY ${year.toString().replace('20', '')}/${(year - 1).toString().replace('20', '')}/${(year - 2).toString().replace('20', '')}`
    }
  }
  const parseMonthYearToDate = (monthYear) => {
    const [month, year] = monthYear?.split('-');
    return new Date(`${month}-${year}`);
  };
  const sortMonthYears = (monthYears) => {
    return monthYears?.sort((a, b) => {
      const dateA = parseMonthYearToDate(a);
      const dateB = parseMonthYearToDate(b);
      return dateA - dateB;
    });
  };

  const data = React.useMemo(() => ({
    labels: lineGraphDataset[selectedButton] ?  [...sortMonthYears(lineGraphDataset[selectedButton].map((val) => val.reported_month_name.replace('20', '')))] : [],
    datasets: [
      {
        label: 'Industry Average',
        data: lineGraphDataset[selectedButton]?.sort((a, b) => parseMonthYearToDate(a.reported_month_name) - parseMonthYearToDate(b.reported_month_name)).map((x) => {
         
          if(value === "1"){
           
            return   ((x.kpivalue) * 100)
          } else {
            return (x.kpivalue)
          }
        }),
        backgroundColor: '#188CE5',
        borderColor: '#188CE5', // This data line will be colored red

        // yAxisID: 'y',
      },
      {
        label: 'Average of top 3 peers',
        data: lineGraphDataset[selectedButton]?.sort((a, b) => parseMonthYearToDate(a.reported_month_name) - parseMonthYearToDate(b.reported_month_name)).map((x) =>{
        
          if(value === "1"){
           
            return   ((x.avgTopValue) * 100)
          } else {
            return (x.avgTopValue)
          }
       
        } ),
        backgroundColor: '#0A558E',
        borderColor: '#0A558E', // This data line will be colored red
        // yAxisID: 'y1',
      }
    ]
  }), [lineGraphDataset, selectedButton]);
  const handleClose = () => {
    // setOpen(false);
    handleOpenClose(false); // Send the data to the parent component
  };

  const config = {
    type: 'line',
    responsive: true,
    plugins: {
      datalabels:{
      display:false
      },
       grid: {
                display: false
            },
      title: {
        display: true,
        // text: 'Chart.js Line Chart',
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      x: {
        grid: {
          display: false
      },
      
        display: true,
        title: {
          display: true,
          text: getAxisLabel(),
          // Adding font object to scale title settings
          font: {
            weight: 'bold',
          },
        },
      },
      y: {
        grid: {
          display: true
      },
      border: {
        dash: [2, 4]
    },
        display: true,
        title: {
          display: true,
          text: dialogTitle,
          // Adding font object to scale title settings
          font: {
            weight: 'bold',
          },
        },
      },
    },
  };




  return (
    <React.Fragment>
    <Dialog
      onClose={handleClose}
      fullWidth='md'
      aria-labelledby="customized-dialog-title"
      open={openClose}
      maxWidth={'md'}
      sx={{
        m: 'auto',
        maxWidth: 'md'
      }}
    >
      <DialogTitle id="customized-dialog-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div><b>{dialogTitle}</b></div>
        <div>
          <Button onClick={() => setSelectedButton('lastThreeYear')} variant={selectedButton === 'lastThreeYear' ? 'text' : 'outlined'}>last 3 years</Button>
          <Button className='button-align'  onClick={() => setSelectedButton('lastYear')} variant={selectedButton === 'lastYear' ? 'text' : 'outlined'}>last year</Button>
          <Button className='button-align'  onClick={() => setSelectedButton('lastSixMonth')} variant={selectedButton === 'lastSixMonth' ? 'text' : 'outlined'}>last 6 months</Button>
          <Button onClick={handleClose} sx={{ color: (theme) => theme.palette.grey[500] }}><b>X</b></Button>
        </div>
      </DialogTitle>

      <DialogContent dividers>
        <div  style={{ height: '100%', minHeight: '400px' }}>          
          <Line data={data} options={value === "1" ?  {
            ...config,
            scales: {
              x: {
                grid: {
                  display: false
              },
              
                display: true,
                title: {
                  display: true,
                  text: getAxisLabel(),
                  // Adding font object to scale title settings
                  font: {
                    weight: 'bold',
                  },
                },
              },
              y: {
                
                ticks: {
                  callback: function (value) {
                      return  value + '%'
                  }
              },
              grid: {
                display: true
            },
            border: {
              dash: [2, 4]
          },
              display: true,
              title: {
                display: true,
                text: dialogTitle,
                // Adding font object to scale title settings
                font: {
                  weight: 'bold',
                },
              },
              }
            }
          }  : config} />
        </div>
      </DialogContent>
    </Dialog>
  </React.Fragment>
);
}